import React, { useEffect, useState } from "react";
import * as S from "../../css/SignUp/RegularUser.style";
import * as A from "../../css/login/login";
import * as B from "../../css/SignUp/signUpRegular";
import { Col, Container, Row } from "react-bootstrap";
import AccordianRegularUser from "./component/AccordianRegularUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { toast } from "wc-toast";
import { postNumbaCodeList } from "../../api/auth";
import ModalConfirm from "../../componant/modal/modalConfirm";
import { BtnLightYellow, CardButton } from "../../css/SignUp/RegularUser.style";

function RegularUser() {
  // const isIOS = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
  const isIOS = () => {   return /iPad|iPhone|iPod|Mac/.test(navigator.userAgent) && !window.MSStream; };
  const location = useLocation();
  const initialState = {
    user_type_cd: "",
    agree_yn: "N",
    privacy_yn: "N",
    alarm_yn: "N",
    ads_yn:"N",
    reg_path_cd: "",
  };
  const [regObj, setRegObj] = useState(initialState);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [isChecked4, setIsChecked4] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  
  const [modalShow, setModalShow] = useState(false);
  const [regPathCdList, setRegPathCdList] = useState([]);


  // 카카오 로그인
  const KAKAO_URL =
    process.env.REACT_APP_KAKAO_HOST_URL +
    "redirect_uri=" +
    process.env.REACT_APP_KAKAO_REDIRECT_URL;

  const handleAllIconClick = () => {
    setIsChecked(!isChecked);
    if (isChecked) {
      setIsChecked1(false);
      setIsChecked2(false);
      setIsChecked3(false);
      setIsChecked4(false);
      setRegObj({ ...regObj, agree_yn: "N", privacy_yn: "N", alarm_yn: "N", ads_yn:"N" });
    } else {
      setIsChecked1(true);
      setIsChecked2(true);
      setIsChecked3(true);
      setIsChecked4(true);
      setRegObj({ ...regObj, agree_yn: "Y", privacy_yn: "Y", alarm_yn: "Y", ads_yn:"Y" });
    }
  };

  const validate = () => {
    if (regObj.agree_yn === "N") {
      toast.error("서비스 이용 약관에 동의해주세요");
    } else if (regObj.privacy_yn === "N"){
      toast.error("개인 정보 취급 방침에 동의해주세요");
    } else if (regObj.alarm_yn === "N") {
      toast.error("매물 시세 수신에 동의해주세요");
    } 
    // else if (regObj.ads_yn === "N") {
    //   toast.error("광고성 정보 수신에 동의해주세요");
    // } 
  };

  const getRegPathCd = async () => {
    try {
      const response = await postNumbaCodeList({ pcd_seq: 300 });
      if (response.code !== 1000) {
        console.log("가입경로 가져오기 실패");
        return;
      }
      setRegPathCdList(response.resultList[0]);
    } catch (err) {
      console.log("가입경로 가져오기 실패");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    
    setRegObj((prevProps) => ({
      ...prevProps,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (isChecked1 && isChecked2 && isChecked3 && isChecked4) {
      setIsChecked(true);
      setIsSignUp(true);
    } else if(isChecked1 && isChecked2 && isChecked3) {
      setIsChecked(false);
      setIsSignUp(true);
    } else {
      setIsChecked(false);
      setIsSignUp(false);
    }
  }, [isChecked, isChecked1, isChecked2, isChecked3, isChecked4]);

  useEffect(() => {
    if (location.state) {
      setRegObj({ ...regObj, ...location.state });
    }
    getRegPathCd();
  }, []);

  useEffect(() => {
    sessionStorage.setItem('regObj', JSON.stringify(regObj));
  }, [regObj]);

  return (
    <>
      <S.Wrapper>
        <Container>
          <Row>
            <Col md={12}>
              <S.MainHeading>일반 회원가입</S.MainHeading>
              <S.SubHeading>약관동의</S.SubHeading>
              <S.SubPara>
                전체동의는 어셈브릭스의 서비스 동의를 포함하고 있습니다.
                <br />
                필수 동의사항 거부시 서비스 이용이 불가능합니다.
              </S.SubPara>
              <S.AccordionDiv>
                <S.AccordionHeading>
                  {isChecked ? (
                    <S.AccordionIcon onClick={handleAllIconClick}>
                      <FontAwesomeIcon icon={faCheck} />
                    </S.AccordionIcon>
                  ) : (
                    <S.AccordionIcon
                      color="#DADADA"
                      onClick={handleAllIconClick}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </S.AccordionIcon>
                  )}
                  <S.AccordionValue>전체동의</S.AccordionValue>
                </S.AccordionHeading>
                <AccordianRegularUser
                  regObj={regObj}
                  setRegObj={setRegObj}
                  setIsChecked={setIsChecked}
                  isChecked1={isChecked1}
                  setIsChecked1={setIsChecked1}
                  isChecked2={isChecked2}
                  setIsChecked2={setIsChecked2}
                  isChecked3={isChecked3}
                  setIsChecked3={setIsChecked3}
                  isChecked4={isChecked4}
                  setIsChecked4={setIsChecked4}
                />
              </S.AccordionDiv>
              <S.AccordionBtn_Div>
                {isSignUp ? (
                  <Link 
                    to={`/signup-regularuser`} 
                    state={regObj}
                    style={{ pointerEvents: 'none' }}
                  >
                    <CardButton bg={"#ff9d2f"} style={{ pointerEvents: 'auto' }}>
                      <span style={{fontStyle:'italic'}}>TOPTOP</span> 회원가입
                    </CardButton>
                  </Link>
                ) : (
                  <CardButton bg={"#C7C7C7"} onClick={validate}>
                    <span style={{fontStyle:'italic'}}>TOPTOP</span> 회원가입
                  </CardButton>
                )}
                {/* {!isIOS() && ( */}
                  {isSignUp ? (
                    // <a href={KAKAO_URL} className="d-flex justify-content-center" 
                    //   style={{ pointerEvents: 'none' }}>
                      <BtnLightYellow
                        mt="20px"
                        color="#000"
                        className="position-relative"
                        style={{ pointerEvents: 'auto' }}
                        onClick={() => setModalShow(true)}
                      >
                        <A.Message_icon
                          src={process.env.PUBLIC_URL + "/img/message_icon.svg"}
                          alt=""
                        ></A.Message_icon>
                        카카오 계정 회원가입
                      </BtnLightYellow>
                    // </a>
                  ) : (
                    <BtnLightYellow
                      mt="20px"
                      color="#000"
                      className="position-relative"
                      onClick={() => {
                        validate();
                      }}
                    >
                      <A.Message_icon
                        src={process.env.PUBLIC_URL + "/img/message_icon.svg"}
                        alt=""
                      ></A.Message_icon>
                      카카오 계정 회원가입
                    </BtnLightYellow>
                  )}
                {/* )} */}
              </S.AccordionBtn_Div>
            </Col>
          </Row>
        </Container>
      </S.Wrapper>
      <ModalConfirm 
        show={modalShow} 
        onHide={() => setModalShow(false)}
        onComfirm={() => {
          setModalShow(false);
          window.location.href = KAKAO_URL;
        }}
        onCancel={() => {
          setModalShow(false);
          setRegObj((prev) => ({...prev, reg_path_cd:""}))
        }} 
        confirmDisabled={!regObj.reg_path_cd}
        title="가입경로 선택"
        // text=""
        action={
          <S.SignUp_Select
            name={"reg_path_cd"}
            placeholder="가입경로를 선택해 주세요"
            className="form-select mt-3"
            onChange={handleInputChange}
          >
            <option value="">가입경로를 선택해 주세요 </option>
            {regPathCdList.map((regPath, index) => (
              <option key={index} value={regPath.cd_seq}>
                {regPath.cd_nm}
              </option>
            ))}
          </S.SignUp_Select>
      }
      />
    </>
  );
}

export default RegularUser;
